module.exports = __webpack_public_path__ + "img/制御工学4_6.0a7dddea.png";